/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForCostCenterDimension extends models.ServiceAccountNativeDetailsBaseForCostCenterDimension {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForCostCenterDimension");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForCostCenterDimension.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForCostCenterDimension>): ServiceAccountNativeDetailsForCostCenterDimension {
        let obj = Object.assign(new ServiceAccountNativeDetailsForCostCenterDimension(), model);
        ServiceAccountNativeDetailsForCostCenterDimension.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForCostCenterDimension>): ServiceAccountNativeDetailsForCostCenterDimension {
        if (!model) return null;
        return ServiceAccountNativeDetailsForCostCenterDimension.newInstance(<ServiceAccountNativeDetailsForCostCenterDimension> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForCostCenterDimension) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForCostCenterDimension.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForCostCenterDimension): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCostCenterDimension.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForCostCenterDimension.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Dimension Id
     */
    dimension_id: string;

}
